import React, { useState } from 'react';
import { Form, Input, Button, Card, Radio, Space } from 'antd';
import { UserOutlined, BankOutlined, PhoneOutlined, EnvironmentOutlined, SafetyCertificateOutlined, GlobalOutlined, EyeOutlined, IdcardOutlined } from '@ant-design/icons';
import LocationPicker from '@components/LocationPicker';
import Preview from './Preview';

const BusinessCardForm = ({ initialValues = {}, onSubmit, loading = false, onCancel }) => {
  const [form] = Form.useForm();
  const [locationPickerVisible, setLocationPickerVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [templateType, setTemplateType] = useState(initialValues.templateType || 1);

  // 处理位置选择
  const handleLocationSelect = (location) => {
    form.setFieldsValue({
      location: {
        address: location.address,
        latitude: location.latitude,
        longitude: location.longitude
      }
    });
    setLocationPickerVisible(false);
  };

  // 处理预览
  const handlePreview = () => {
    form.validateFields().then(() => {
      setPreviewVisible(true);
    }).catch(() => {
      // 表单验证失败
    });
  };

  // 处理取消
  const handleCancel = () => {
    form.resetFields();
    setTemplateType(1);
    onCancel?.();
  };

  // 处理提交
  const handleSubmit = async (values) => {
    await onSubmit(values);
  };

  return (
    <div style={{ display: 'flex', gap: '24px' }}>
      <Card
        title="编辑名片信息"
        style={{ flex: 1 }}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ ...initialValues, templateType }}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="templateType"
            label="选择模板"
            rules={[{ required: true, message: '请选择模板' }]}
          >
            <Radio.Group onChange={(e) => setTemplateType(e.target.value)}>
              <Radio.Button value={1}>模板一</Radio.Button>
              <Radio.Button value={2}>模板二</Radio.Button>
              <Radio.Button value={3}>模板三</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="company"
            label="单位"
            rules={[{ required: true, message: '请输入单位名称' }]}
          >
            <Input prefix={<BankOutlined />} placeholder="请输入单位名称" />
          </Form.Item>

          <Form.Item
            name="name"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="请输入姓名" />
          </Form.Item>

          <Form.Item
            name="position"
            label="职位"
            rules={[{ required: true, message: '请输入职位' }]}
          >
            <Input prefix={<IdcardOutlined />} placeholder="请输入职位" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="电话"
            rules={[{ required: true, message: '请输入电话号码' }]}
          >
            <Input prefix={<PhoneOutlined />} placeholder="请输入电话号码" />
          </Form.Item>

          <Form.Item
            name="supervisionPhone"
            label="监督电话"
            rules={[{ required: true, message: '请输入监督电话' }]}
          >
            <Input prefix={<SafetyCertificateOutlined />} placeholder="请输入监督电话" />
          </Form.Item>

          <Form.Item
            label="营业所站地址"
            required
            tooltip="点击选择位置按钮在地图上选择准确位置"
          >
            <Input.Group compact>
              <Form.Item
                name={['location', 'address']}
                noStyle
                rules={[{ required: true, message: '请选择地址' }]}
              >
                <Input
                  prefix={<EnvironmentOutlined />}
                  placeholder="请选择地址"
                  readOnly
                  style={{ width: 'calc(100% - 120px)' }}
                />
              </Form.Item>
              <Button
                type="primary"
                onClick={() => setLocationPickerVisible(true)}
              >
                选择位置
              </Button>
            </Input.Group>
            <Form.Item name={['location', 'latitude']} hidden>
              <Input />
            </Form.Item>
            <Form.Item name={['location', 'longitude']} hidden>
              <Input />
            </Form.Item>
          </Form.Item>

          <Form.Item
            name="serviceArea"
            label="服务范围"
            tooltip={`中间需用"、"隔开！！！否则将影响名片布局！！！`}
            rules={[{ required: true, message: '请输入服务范围' }]}
          >
            <Input.TextArea
              prefix={<GlobalOutlined />}
              placeholder={`请输入服务范围，需用"、"隔开。如：小区A、小区B`}
              rows={4}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="default" onClick={handlePreview} icon={<EyeOutlined />}>
                预览
              </Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                保存
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <LocationPicker
        visible={locationPickerVisible}
        onCancel={() => setLocationPickerVisible(false)}
        onOk={handleLocationSelect}
        initialLocation={form.getFieldValue('location')}
      />

      <Preview
        visible={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        data={form.getFieldsValue()}
        templateType={templateType}
      />
    </div >
  );
};

export default BusinessCardForm;

